<script lang="ts" setup>
    const props = defineProps<{ blok: ButtonLinkStoryblok }>();
</script>
<template>
    <PrimaryButton
        v-editable="props.blok"
        :button-text="props.blok.text"
        :button-href="
            props.blok.isDownload && props.blok.textDownload?.filename
                ? props.blok.textDownload.filename
                : useStoryblokUrl(props.blok.link)
        "
        :has-icon="props.blok.hasIcon"
        :disabled="props.blok.disabled"
        :is-download="props.blok.isDownload"
        :variant="props.blok.variant"
        :size="props.blok?.size || undefined"
        :retain-size="props.blok.retainSize"
        :alignment="props.blok?.alignment || undefined"
        :open-new-tab="props.blok?.link?.target === '_blank'"
    />
</template>
